/**
 * The persistent-notice half of account activation, for the sidebar alert
 * region. Deliberately separate from ResendActivationInfo.js, which is
 * still used inline on IntegrationCard.js (a page-specific prompt, not an
 * account-level notice — see design_handoff_sidebar_alerts README) and is
 * left untouched.
 */
import { useUserStore } from "../../../../../hooks/redux/user";

export function useResendActivationAlert() {
  const { user, resendActivationToken } = useUserStore();

  if (!user.model || user.model.is_account_verified) {
    return null;
  }

  if (user.resendActivationSuccess) {
    return {
      id: "resendActivation",
      variant: "warning",
      icon: "AlertTriangle",
      title: "Account not activated",
      body: `Activation link sent to ${user.model.email}. Check your inbox.`,
    };
  }

  return {
    id: "resendActivation",
    variant: "warning",
    icon: "AlertTriangle",
    title: "Account not activated",
    body: user.resendActivationError
      ? "Couldn't resend the link — try again."
      : "Confirm your email to unlock your free trial.",
    action: {
      label: "Resend activation link",
      onClick: () => resendActivationToken(),
    },
  };
}

export default useResendActivationAlert;
